export function tableNodeTypes(schema) {
  let result = schema.cached.tableNodeTypes;

  if (!result) {
    result = {}; // eslint-disable-next-line no-param-reassign

    schema.cached.tableNodeTypes = result; // eslint-disable-next-line guard-for-in

    for (const name in schema.nodes) {
      const type = schema.nodes[name];
      const role = type.spec.tableRole;

      if (role) {
        result[role] = type;
      }
    }
  }

  return result;
}